(() => {
  'use strict';
  if (window.LRSThemeReady) return;
  window.LRSThemeReady = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const isEditor = Boolean(window.Shopify?.designMode);
  const motion = () => !reduced.matches && document.body.dataset.lrsMotion !== 'false' && !isEditor;
  if (isEditor) document.documentElement.classList.add('shopify-design-mode');
  const observed = new WeakSet();
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); } });
  }, {threshold: .08}) : null;
  const processObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    const current = entries.filter(e => e.isIntersecting).sort((a,b) => a.boundingClientRect.top-b.boundingClientRect.top)[0];
    if (current) document.querySelectorAll('.process-nav a').forEach(a => {
      if (a.hash === '#' + current.target.id) a.setAttribute('aria-current', 'step'); else a.removeAttribute('aria-current');
    });
  }, {rootMargin: '-15% 0px -45% 0px', threshold: 0}) : null;
  function initialize(root = document) {
    const menu = document.querySelector('#site-menu');
    const menuButton = document.querySelector('.menu-toggle');
    if (menuButton && typeof menu?.showModal === 'function') menuButton.hidden = false;
    if (motion() && revealObserver) {
      document.documentElement.classList.add('motion-ready');
      root.querySelectorAll('[data-reveal]').forEach(el => { if (!observed.has(el)) { observed.add(el); revealObserver.observe(el); } });
    } else document.documentElement.classList.remove('motion-ready');
    root.querySelectorAll('[data-process-step]').forEach(el => processObserver?.observe(el));
  }
  initialize();
  document.addEventListener('shopify:section:load', event => { initialize(event.target); scheduleScroll(); });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-reveal]').forEach(el => revealObserver?.unobserve(el));
    event.target.querySelectorAll('[data-process-step]').forEach(el => processObserver?.unobserve(el));
    if (event.target.querySelector('dialog[open]')) document.body.style.overflow = '';
  });
  reduced.addEventListener('change', () => { initialize(); scheduleScroll(); });
  let frame = false;
  function updateScroll() {
    const y = window.scrollY;
    document.querySelector('.site-header')?.classList.toggle('is-scrolled', y > 20);
    const heroImage = document.querySelector('.hero-image img');
    if (heroImage) heroImage.style.transform = motion() && window.innerWidth > 700 && y < window.innerHeight * 1.5 ? `scale(1.08) translateY(${Math.min(y * .045, 30)}px)` : '';
    frame = false;
  }
  function scheduleScroll() { if (!frame) { frame = true; window.requestAnimationFrame(updateScroll); } }
  window.addEventListener('scroll', scheduleScroll, {passive: true});
  window.addEventListener('resize', scheduleScroll, {passive: true});
  window.addEventListener('pageshow', scheduleScroll);
  updateScroll();
  const returnFocus = new WeakMap();
  function openDialog(dialog) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    if (dialog.open) return true;
    returnFocus.set(dialog, document.activeElement);
    dialog.showModal();document.body.style.overflow = 'hidden';
    if (dialog.id === 'site-menu') document.querySelector('.menu-toggle')?.setAttribute('aria-expanded', 'true');
    return true;
  }
  document.addEventListener('close', event => {
    if (event.target.tagName !== 'DIALOG') return;
    if (event.target.id === 'site-menu') document.querySelector('.menu-toggle')?.setAttribute('aria-expanded', 'false');
    if (!document.querySelector('dialog[open]')) document.body.style.overflow = '';
    returnFocus.get(event.target)?.focus();
  }, true);
  const desktopMenu = window.matchMedia('(min-width: 1001px)');
  desktopMenu.addEventListener('change', event => {
    if (event.matches) document.querySelector('#site-menu[open]')?.close();
  });
  let gallery = [], index = 0;
  function showImage(next) {
    if (!gallery.length) return;
    index = (next + gallery.length) % gallery.length;
    const selected = gallery[index], image = document.querySelector('#lightbox-image');
    if (!image) return;
    document.querySelector('#lightbox')?.dispatchEvent(new CustomEvent('lrs:lightbox:imagechange'));
    image.src = selected.dataset.image;image.alt = selected.dataset.imageAlt || selected.dataset.caption || '';
    image.decoding = 'async';
    document.querySelector('#lightbox-caption').textContent = selected.dataset.caption || '';
    document.querySelector('#lightbox-counter').textContent = `${String(index+1).padStart(2,'0')} / ${String(gallery.length).padStart(2,'0')}`;
    document.querySelector('#lightbox-prev').disabled = document.querySelector('#lightbox-next').disabled = gallery.length < 2;
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target.closest('.menu-toggle')) { openDialog(document.querySelector('#site-menu')); return; }
    if (target.closest('.menu-close')) { document.querySelector('#site-menu')?.close();return; }
    if (target.closest('#site-menu a')) document.querySelector('#site-menu')?.close();
    const button = target.closest('[data-gallery]');
    if (button) {
      gallery = Array.from(document.querySelectorAll('[data-gallery]')).filter(el => el.dataset.gallery === button.dataset.gallery);
      showImage(gallery.indexOf(button));
      if (!openDialog(document.querySelector('#lightbox'))) window.open(button.dataset.image, '_blank', 'noopener');
      return;
    }
    if (target.closest('#lightbox-prev')) showImage(index - 1);
    if (target.closest('#lightbox-next')) showImage(index + 1);
    if (target.closest('#lightbox-close')) document.querySelector('#lightbox')?.close();
  });
  document.addEventListener('keydown', event => {
    if (!document.querySelector('#lightbox')?.open || event.altKey || event.ctrlKey || event.metaKey || window.LRSDetailZoom?.isZoomed()) return;
    if (event.key === 'ArrowLeft') { event.preventDefault();showImage(index - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault();showImage(index + 1); }
  });
})();
